import { CaseRotationStatus, NEW_CASES_ROTATION_GROUP } from '#entities';
import { ENOPOrganType, type Point } from '#shared';

import { EZLayers, ZLayer } from '../../data-context';

import { StyledDot } from './StyledDot';

interface Props {
  id: string;
  position?: Point;
  activeRotationStatus?: CaseRotationStatus;
  isRotationActive?: boolean;
  organType: ENOPOrganType;
}

export const NewAlertLine = ({
  id,
  position,
  activeRotationStatus,
  isRotationActive,
  organType,
}: Props) => {
  const highlightCase = activeRotationStatus === NEW_CASES_ROTATION_GROUP;
  const highlightedOpacity = isRotationActive ? (highlightCase ? 1 : 0.2) : 1;

  return position ? (
    <ZLayer zIndex={EZLayers.Background}>
      <g
        id={`${id}-point`}
        transform={`translate(${position[0]}, ${position[1]})`}
        style={{
          opacity: highlightedOpacity,
          transition: 'opacity 1s ease',
          fill: 'transparent',
          strokeWidth: 1.5,
          filter: 'drop-shadow(0 0.75px 1.3px #00000040)',
        }}
      >
        {/* organ-colored filled dot + orange ring for new case */}
        <StyledDot organType={organType} isNewCase />
      </g>
    </ZLayer>
  ) : null;
};
